import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { PessoaCadastro } from '@core/models/pessoa';
import { HttpHeaders } from '@angular/common/http';
import { buildQueryString } from '@shared/util/util';
import { DomainCacheService } from './domain-cache.service';
import { Observable } from 'rxjs';


const baseRef = 'vinculo';
const baseRefContato = 'vinculo-contato';
const route = {
  consultar: `${baseRef}/consultar`,
  consultarCombo: `${baseRef}/consultar-combo`,
  consultarGrid: `${baseRef}/consultar-grid`,
  salvar: `${baseRef}`,
  editar: `${baseRef}`,
  buscarPorid: (id: number) => `${baseRef}/${id}`,
  buscarPorIdBasico: (id: number) => `${baseRef}/${id}/basico`,
  buscarPoridEntidade: (id: number) => `${baseRef}/consultarPorEntidade/${id}`,
  buscarPoridEntidadeCombo: (id: number) => `${baseRef}/consultarPorEntidadeCombo/${id}`,
  listarPorEntidadeId: (entidadeAdministradoraId: number) => `${baseRef}/entidade/${entidadeAdministradoraId}`,
  pessoaPaginado: `${baseRef}/consultar-combo-paginado`,
  listarPorFederacao: `${baseRef}/listar-por-federacao`,
  listarPorCargoReferencia: `${baseRef}/listar-por-cargo-referencia`,
  listarPorVinculo: `${baseRef}/vinculo-combo`,
  listarPorTipoVinculo: `${baseRef}/tipo-vinculo-combo`,
  listarPorVinculoEfetivo: (id: number) => `${baseRef}/vinculo-efetivo-combo/${id}`,
  tabelaVinculoPessoa: (id: number) => `${baseRef}/pessoa/${id}`,
  tabelaVinculoEntidade: (id: number) => `${baseRef}/entidade/${id}`,
  cargoRepresentanteCombo: (id: any) => `${baseRef}/cargo-representada-combo/${id}`,
  listarPesssoaAdministradoraCombo: (id: any) => `${baseRef}/pessoa-administradora-combo/${id}`,
  listarContatoPessoaVinculo: (id: any) => `${baseRef}/buscar-contato-vinculo?idPessoa=${id}`,
  listarContatoEntidadeVinculo: (id: number, principal: boolean) => `${baseRef}/buscar-contato-vinculo?principal=${principal}&idEntidade=${id}`,
  listarContatoVinculoVinculo: (id: any) => `${baseRef}/buscar-contato-vinculo-por-pessoa?idPessoa=${id}`,
  buscarPorPessoaEntidadeRepresentada: (idPessoa: any, idEntidadeRepresentada: any) => `${baseRef}/buscar-vinculo-por-pessoa-representada/${idPessoa}/${idEntidadeRepresentada}`,
  buscarPorEntidade: (idEntidade: any) => `${baseRef}/buscar-vinculo-por-entidade/${idEntidade}`,
  buscarPorVinculoPrincipal: (idVinculo: any) => `${baseRef}/buscar-vinculo-por-vinculo-principal/${idVinculo}`,
  editarVinculosContatos: `${baseRefContato}/entidade`,
  editarVinculoVinculoContatos: `${baseRefContato}/vinculo`,
  remover: (idVinculo: any) => `${baseRef}/${idVinculo}`,
  entidadeMandato: (idEntidade: any) => `mandatos/entidade/${idEntidade}`,
  buscarRepresentacaoPessoa: (idVinculo: number) => `${baseRef}/buscar-representacao-pessoa/${idVinculo}`,
  removerVinculo: (idVinculo: any) => `${baseRef}/${idVinculo}`,
  podeCadastrarVinculo: (idEntidade: any) => `${baseRef}/pode-cadastrar/${idEntidade}`,
  verificarSeOVinculoEusadoComoVinculoRepresentado: (idVinculo: number) => `${baseRef}/verificar-vinculo-representado/${idVinculo}`,
  reativar: (idVinculo: number) => `${baseRef}/reativar-vinculo/${idVinculo}`

}

@Injectable({
  providedIn: 'root'
})
export class VinculoService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  consultar(filtro: any, page?: MatPageable, ignoreLoading = false) {
    const query = page?.query ?? '?page=0&size=10';
    return this.apiService.post<PageableResponse<any>>(
      `${route.consultar}${query}`,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }

  consultarSort(filtro: any, page: MatPageable, params: any, ignoreLoading = false) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }


  consultarGrid(filtro: any, page?: MatPageable) {
    const query = page?.query ?? '?page=0&size=10';
    return this.apiService.post<PageableResponse<any>>(
      `${route.consultarGrid}${query}`,
      this.apiService.removeNullPropertys(filtro)
    );
  }



  consultarCombo() {
    return this.apiService.get<any[]>(route.consultarCombo);


  }

  pessoaComboPaginado(filtro: any) {
    return this.apiService.get<any>(`${route.pessoaPaginado}/${filtro}`);

  }


  salvar(pessoa: PessoaCadastro) {
    return this.apiService.post<any>(route.salvar, pessoa);
  }

  buscarPorIdBasico(id: number) {
    return this.apiService.get<any>(route.buscarPorIdBasico(id));
  }

  buscarPorId(id: number, ignoreLoading = false) {
    return this.apiService.get<any>(route.buscarPorid(id), undefined, undefined, ignoreLoading);
  }

  editar(pessoa: PessoaCadastro) {
    return this.apiService.put<any>(route.editar, pessoa);
  }



  listarPorEntidadeId(entidadeAdministradoraId: number) {
    return this.apiService.get<any>(route.listarPorEntidadeId(entidadeAdministradoraId));
  }

  listarPorFederacao() {
    return this.apiService.get<any>(`${route.listarPorFederacao}`);
  }


  listarPorCargoReferencia() {
    return this.apiService.get<any>(`${route.listarPorCargoReferencia}`);
  }

  listarPorVinculo() {
    return this.apiService.get<any>(`${route.listarPorVinculo}`);
  }

  listarPorTipoVinculo() {
    return this.domainCache.getOrLoad('vinculo/tipo-vinculo-combo', () =>
      this.apiService.get<any>(`${route.listarPorTipoVinculo}`, undefined, undefined, true)
    );
  }

  listarPorVinculoEfetivo(id: any) {
    return this.apiService.get<any>(`${route.listarPorVinculoEfetivo(id)}`);
  }


  // buscarPorIdEntidade(id: number) {
  //   return this.apiService.get<any>(route.buscarPoridEntidade(id));
  // }

  buscarPorIdEntidade(id: number, page: MatPageable) {
    return this.apiService.get<PageableResponse<any>>(`${route.buscarPoridEntidade(id)}${page.query}`);
  }

  listarPorVinculoEntidade(id: number, incluirNomeEntidade = true) {
    return this.apiService.get<any>(`${route.buscarPoridEntidadeCombo(id)}?incluirNomeEntidade=${incluirNomeEntidade}`);
  }

  tabelaVinculoPessoa(id: number) {
    return this.apiService.get<any>(`${route.tabelaVinculoPessoa(id)}`);
  }

  tabelaVinculoEntidade(id: number) {
    return this.apiService.get<any>(`${route.tabelaVinculoEntidade(id)}`);
  }

  listarCargoRepresentanteCombo(idVinculo: any) {
    return this.apiService.get<any>(`${route.cargoRepresentanteCombo(idVinculo)}`, undefined, undefined, true);
  }


  listarPesssoaAdministradoraCombo(idEntidade: any) {
    return this.apiService.get<any>(`${route.listarPesssoaAdministradoraCombo(idEntidade)}`);
  }

  listarContatoPessoaVinculo(idPessoa: any) {
    return this.apiService.get<any>(`${route.listarContatoPessoaVinculo(idPessoa)}`);
  }

  listarContatoEntidadeVinculo(idEntidade: number, principal: any) {
    return this.apiService.get<any>(`${route.listarContatoEntidadeVinculo(idEntidade, principal)}`, undefined, undefined, true);
  }

  listarContatoVinculoVinculo(idPessoa: any) {
    return this.apiService.get<any>(`${route.listarContatoVinculoVinculo(idPessoa)}`, undefined, undefined, true);
  }

  buscarPorPessoaEntidadeRepresentada(idPessoa: any, idEntidadeRepresentada: any) {
    return this.apiService.get<any>(`${route.buscarPorPessoaEntidadeRepresentada(idPessoa, idEntidadeRepresentada)}`);
  }

  buscarPorEntidade(idEntidade: any) {
    return this.apiService.get<any>(`${route.buscarPorEntidade(idEntidade)}`);
  }

  buscarPorVinculoPrincipal(idVinculo: any) {
    return this.apiService.get<any>(`${route.buscarPorVinculoPrincipal(idVinculo)}`);
  }



  editarVinculosContatos(obj: any) {
    return this.apiService.put(`${route.editarVinculosContatos}`, obj)
  }

  editarVinculoVinculoContatos(obj: any) {
    return this.apiService.put(`${route.editarVinculoVinculoContatos}`, obj)
  }

  remover(idVinculo: any) {
    return this.apiService.delete(`${route.remover(idVinculo)}`);
  }

  entidadeMandato(idEntidade: any) {
    return this.apiService.get(`${route.entidadeMandato(idEntidade)}`);
  }

  buscarRepresentacaoPessoa(idVinculo: number) {
    return this.apiService.get(route.buscarRepresentacaoPessoa(idVinculo));
  }

  verificarSeOVinculoEusadoComoVinculoRepresentado(idVinculo: number) {
    return this.apiService.get(route.verificarSeOVinculoEusadoComoVinculoRepresentado(idVinculo));
  }

  removerVinculo(idVinculo: number, obj: any) {
    return this.apiService.delete(route.removerVinculo(idVinculo), obj);
  }

  podeCadastrarVinculo(idEntidade: number) {
    return this.apiService.get<any>(route.podeCadastrarVinculo(idEntidade));
  }


  reativarVinculo(idVinculo: number) {
    return this.apiService.get(route.reativar(idVinculo));
  }
}
